var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullscreenCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.821,
    height: 34.821,
    viewBox: "0 0 34.821 34.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_121",
    "data-name": "Groupe 121",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M31.865,31.865H11.386V11.386H31.865ZM13.906,29.345h15.44V13.905H13.906Z",
    transform: "translate(-4.215 -4.215)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M45.942,36.845v9.1h-9.1v2.519H48.461V36.845Z",
    transform: "translate(-13.64 -13.64)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_96",
    "data-name": "Trac\\xE9 96",
    d: "M0,0V11.616H2.519V2.52h9.1V0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M36.845,0V2.52h9.1v9.1h2.519V0Z",
    transform: "translate(-13.64)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M0,36.845V48.461H11.617V45.942h-9.1v-9.1Z",
    transform: "translate(0 -13.64)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 34.821,
    y2: 34.821,
    stroke: "#000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenCloseBlack);
export default __webpack_public_path__ + "static/media/icon-fullscreen-close-black.942bfa3f79e6338a90db43a9734754ce.svg";
export { ForwardRef as ReactComponent };